import { parse } from "date-fns";

export const getAttributeList = (value?: any, defaultValue?: any) => {
  defaultValue = defaultValue || [];
  return value
    ? Array.isArray(value || [])
      ? value || []
      : [value]
    : defaultValue;
};

export const getDateAttribute = (value?: any, defaultDate?: any) => {
  return value
    ? parse(value, "yyyy-MM-dd", new Date())
    : defaultDate || new Date();
};
